<div class="page-header row d-flex align-items-center">
    <div class="col-sm me-auto">
        <h1>Inventory</h1>
    </div>
    <!-- TODO: search and sort
  <div class="col-sm">
    <form class="row">
      <div class="col">
        <input type="text" placeholder="keyword search" class="form-control">
      </div>
      <div class="col-auto">
        <button type="submit" class="btn btn-primary">search</button>
      </div>
    </form>
  </div>
  <div class="col-sm">
    <select class="form-select">
      <option selected>sort</option>
      <option>a</option>
      <option>b</option>
      <option>c</option>
    </select>
  </div>
  -->
</div>
<div class="row">
    @if (coreAppService.uiStateService.isMobile()) {
        @for (stack of groupedItems(); track stack.instances[0].ItemType.Id) {
            <app-item-card
                [item]="stack.instances[0]"
                [quantity]="stack.instances.length"
                [stackInstances]="stack.instances"
                [isInventoryContext]="true"
                class="col-md-6 col-lg-3 text-center mb-3"
                animate.enter="item-card-enter-mobile"
                animate.leave="item-card-leave-mobile"></app-item-card>
        }
    } @else {
        @for (stack of groupedItems(); track stack.instances[0].ItemType.Id) {
            <app-item-card
                [item]="stack.instances[0]"
                [quantity]="stack.instances.length"
                [stackInstances]="stack.instances"
                [isInventoryContext]="true"
                class="col-md-6 col-lg-3 text-center mb-3"
                animate.enter="item-card-enter-desktop"
                animate.leave="item-card-leave-desktop"></app-item-card>
        }
    }

    @if (groupedItems().length == 0) {
        <div>You don't have any items :(</div>
    }
</div>
